import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import graphicalOn from '../../../assets/graphical_view_on.png';
import graphicalOff from '../../../assets/graphical_view_off.png';
import tabularOn from '../../../assets/tabular_view_on.png';
import tabularOff from '../../../assets/tabular_view_off.png';

import Treemap from '../../../components/Treemap';
import AnalystDetailsTable from './AnalystDetailsTable';

import style from './index.scss';

const TABULAR_VIEW = 0;
const GRAPH_VIEW = 1;

class AnalystDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentView: GRAPH_VIEW
    };
  }

  onToggleGraphView = () => {
    if (this.state.currentView !== GRAPH_VIEW) {
      this.setState({
        currentView: GRAPH_VIEW
      });
    }
  };

  onToggleTabularView = () => {
    if (this.state.currentView !== TABULAR_VIEW) {
      this.setState({
        currentView: TABULAR_VIEW
      });
    }
  };

  renderGraphView = () => {
    const { data } = this.props;
    if (data) {
      return (
        <div className={classnames(style.dashboardChart)}>
          <div className={classnames(['card col-md-12', style.cardWrapper])}>
            <div className={classnames(style.cardHeaderMore)}>
              <div className={classnames('row')}>
                <div className={classnames('col-md-4')}>Analyst Details</div>

                <div className={classnames('col-md-8 text-right')}>
                  {this.renderViewSwitcher()}
                </div>
              </div>
            </div>
            <div className={classnames('card-body', style.cardBodyMore)}>
              <div className={classnames('col-md-12')}>
                <Treemap data={data} dataKey="avg_30_days" />
              </div>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  renderTabularView = () => {
    if (this.props.data) {
      return (
        <div className={classnames(style.dashboardChart)}>
          <div className={classnames(['card col-md-12', style.cardWrapper])}>
            <div className={classnames(style.cardHeaderMore)}>
              <div className={classnames('row')}>
                <div className={classnames('col-md-4')}>Analyst Details</div>

                <div className={classnames('col-md-8 text-right')}>
                  {this.renderViewSwitcher()}
                </div>
              </div>
            </div>
            <div className={classnames('card-body', style.cardBodyMore)}>
              <div className={classnames('row')}>
                <div className={classnames('col-md-12')}>
                  <AnalystDetailsTable data={this.props.data} />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  renderViewSwitcher = () => {
    const { currentView } = this.state;
    return (
      <div className="btn-group">
        <button onClick={() => this.onToggleGraphView()}>
          <img
            src={currentView === GRAPH_VIEW ? graphicalOn : graphicalOff}
            alt="graphical view"
          />
        </button>
        <button onClick={() => this.onToggleTabularView()}>
          <img
            src={currentView === TABULAR_VIEW ? tabularOn : tabularOff}
            alt="tabular view"
          />
        </button>
      </div>
    );
  };

  render() {
    const { currentView } = this.state;
    if (currentView === GRAPH_VIEW) {
      return this.renderGraphView();
    }

    return this.renderTabularView();
  }
}

AnalystDetails.propTypes = {
  data: PropTypes.array
};

export default AnalystDetails;
